import React, { useEffect, useState } from 'react';
import { PhotoProvider } from 'react-photo-view';
import useTitle from '../../hooks/useTittle';
import Service from '../Home/Services/Service/Service';
import Spinner from '../Spinner/Spinner';
import './Foods.css';

const Foods = () => {
    useTitle('Foods');
    const [foods, setfoods] = useState([]);
    const [isLoading, setLoading] = useState(false);
    useEffect(() => {
        setLoading(true)
        fetch('https://salma-kitchen-server.vercel.app/foods')
            .then(res => res.json())
            .then(data => {
                setfoods(data);
                setLoading(false);
            });


    }, []);

    return (
        <div>
            
            <div className="page-head mb-12 bg-amber-400 flex items-center justify-center">
                <h1 className="text-8xl font-extrabold">Foods</h1>
            </div>
            <h1 className="text-5xl text-center font-extrabold px-5">Chose your need</h1>
            {
                isLoading ?
                    <Spinner></Spinner>
                    :
                    <PhotoProvider>
                    <div className="service-card-container grid sm:grid-cols-1 md:grid-cols-3 gap-10 pt-12 px-5 lg:px-24 mb-24">
                         
                        {
                           
                            foods.map(food => <Service key={food._id} food={food} ></Service>)
                            
                        }
                       
                    </div>
                    </PhotoProvider>
            }
        </div>
    );
};

export default Foods;